module.exports = __webpack_public_path__ + "static/img/RAPS800_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS800_1.png
// module id = QrAh
// module chunks = 0